/**
 * Static (single-frame) GIF encoding via `gifenc` — chosen over `gif.js` because
 * it's synchronous and dependency-free (no Web Worker script to bundle/serve
 * separately). Lazy-imported here so it never lands in the main bundle; only
 * users who pick GIF as the output format pull it in.
 */
export const encodeStaticGif = async (canvas: HTMLCanvasElement): Promise<Blob> => {
  const {GIFEncoder, quantize, applyPalette} = await import('gifenc')

  const ctx = canvas.getContext('2d')
  if (!ctx) throw new Error('Canvas 2D context unavailable')
  const {width, height} = canvas
  const rgba = ctx.getImageData(0, 0, width, height).data

  const palette = quantize(rgba, 256)
  const index = applyPalette(rgba, palette)

  const gif = GIFEncoder()
  gif.writeFrame(index, width, height, {palette})
  gif.finish()

  // Copy into a fresh Uint8Array so its `.buffer` is a plain ArrayBuffer, not
  // ArrayBufferLike — Blob's BlobPart type rejects the latter (TS strictness).
  return new Blob([new Uint8Array(gif.bytes())], {type: 'image/gif'})
}
